import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MaterialSelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const Select = ({
  className,
  input,
  label,
  placeholder,
  options,
  meta: {
    touched,
    error,
  },
}) => (
  <FormControl
    error={Boolean(touched && error)}
  >
    <InputLabel>{label}</InputLabel>
    <MaterialSelect
      label={label}
      className={className}
      placeholder={placeholder}
      onChange={input.onChange}
      value={input.value}
    >
      {options.map(({
        id,
        name,
      }) => (
        <MenuItem
          key={id}
          value={id}
        >
          {name}
        </MenuItem>
      ))}
    </MaterialSelect>
  </FormControl>
);

Select.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.string,
    ]),
  }),
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
};

Select.defaultProps = {
  className: '',
  input: {
    onChange: () => {},
  },
  label: '',
  meta: {
    touched: false,
    error: [],
  },
  placeholder: '',
};

export default Select;



// WEBPACK FOOTER //
// ./src/common/components/Select/Select.js